import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";

function ContractShortview({ contract, customerPermission, TotalIncome, iir, display,netinvest, Loanpricipal }) {
  let navigate = useNavigate();
  const isLoanFamily = contract.contract_type === "Loan" || contract.contract_type === "Line of Credit";

  const handlePartyView = (id) => {
    if (customerPermission !== 'Customer') {
      navigate("/party/details", { state: id });
    }
  };
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");
  console.log("contractshortview", contract , netinvest, Loanpricipal);

  return (
    <div className="header pb-0 ">
      <div className="d-lg-flex row pt-2">
        <div className="col-xl-6">
          <h5 className="mb-3 text-md-start">{t("Contract Details")}</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="col-md-10">
            <div className="row">
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className=" sub-title tc">
                  {t("Sub Company")}{" "}
                  <Tooltip content={t("Subcompany_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className="party-detail-font">
                    {contract.subcompany_name?contract.subcompany_name:"None"}
                  </span>
                </div>
              </div>
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className=" sub-title tc">
                  {t("Line of Business")}{" "}
                  <Tooltip content={t("Lineofbusiness_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className="party-detail-font">
                    {contract.line_of_business_name?contract.line_of_business_name:"None"}
                  </span>
                </div>
              </div>
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className=" sub-title tc">
                  {t("Contract Number")}{" "}
                  <Tooltip content={t("Contract_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className="party-detail-font">
                    {contract.contract_number}
                  </span>
                </div>
              </div>
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className=" sub-title tc">
                  {t("Contract Type")}{" "}
                  <Tooltip content={t("ContractType_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className=" party-detail-font">
                    {contract.contract_type}
                  </span>
                </div>
              </div>
            </div>
            <div className=" row">
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className="sub-title tc">
                  {t("Customer")}{" "}
                  <Tooltip content={t("Customer_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span
                    className=" party-detail-font  hyperlink"
                    onClick={() =>
                      permissionss &&
                        permissionsArray.includes("view_party") === true
                        ? handlePartyView(contract.party)
                        : null
                    }
                  >
                    {contract.customer_name}
                  </span>
                </div>
              </div>
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className="sub-title tc">
                  {t("Status")}{" "}
                  <Tooltip content={t("Status_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className=" party-detail-font">{contract.status}</span>
                </div>
              </div>
            </div>
            <div className=" row">
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className="sub-title tc">
                  {t("Start Date")}{" "}
                  <Tooltip content={t("StartDate_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className=" party-detail-font">
                    {Helper.DateNormal(contract.start_date)}
                  </span>
                </div>
              </div>
              <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                <span className="sub-title tc">
                  {t("End Date")}{" "}
                  <Tooltip content={t("EndDate_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </span>
                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                  <span className=" party-detail-font">
                    {Helper.DateNormal(contract.end_date)}
                  </span>
                </div>
              </div>
              {
                contract.contract_type === 'Rental' ?
                  "" :

                  customerPermission !== "Customer" ?

                    display === true ?
                      <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                        <span className="sub-title tc">
                          {t("IRR/Interest p.a.")}{" "}
                          <Tooltip content={t("IRR/Interest p.a.")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </span>
                        <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                          <span className=" party-detail-font">
                            {Helper.Amount(iir)}
                          </span>
                        </div>
                      </div>

                      : ""
                    : ""
              }
              {
                display === true ?
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className="sub-title tc">
                      {/* {t("Total Income")}{" "} */}
                      {isLoanFamily ? t("Total Interest") : t("Total Income")}
                      <Tooltip content={isLoanFamily ? t("Total Interest") : t("Total Income")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className=" party-detail-font">
                        {Helper.Amount(TotalIncome)}
                      </span>
                    </div>
                  </div> : ''
              }
            </div>
            <div className=" row"></div>
            <div className=" row"></div>
            <div className="row">
              {isLoanFamily ? (
                <>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className="sub-title tc">
                      {t("Payment Start Date")}{" "}
                      <Tooltip content={t("PaymentStartDate_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className=" party-detail-font">
                        {contract.paymentstartdate
                          ? Helper.DateNormal(contract.paymentstartdate)
                          : "None"}
                      </span>
                    </div>
                  </div>
                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                    <span className="sub-title tc">
                      {t("Loan Amount")}{" "}
                      <Tooltip content={t("LoanAmount_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </span>
                    <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                      <span className=" party-detail-font">
                        {contract.loanamount
                          ? Helper.Amount(
                            contract.loanamount - contract.deposit_amount
                          )
                          : "None"}
                      </span>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className=" row">
          {
                              isLoanFamily  && contract.status === "Active" ?
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <label className=" col-form-label">
                                      {/* {t("Contract Exposure")}{" "} */}
                                      {t("Loan Principal")}{" "}
                                      <Tooltip content={t("LoanPrincipal_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                  </label>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className=" view-label p">
                                          {
                                              contract.status === "Active" ?

                                                  contract.contract_type === "Rental" ?
                                                      (
                                                          // Helper.Amount(contractdetail.totalRent * contractdetail.Contract.contract_term + contractdetail.residalvalue)
                                                          Helper.Amount(netinvest || 0)
                                                      )
                                                      :
                                                      (
                                                          Helper.Amount(Loanpricipal || 0)
                                                      )
                                                  : 0.00
                                          }
                                      </span>
                                  </div>
                              </div>:
                              contract.status === "Active" && (
                                <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                  <label className=" col-form-label">
                                      {/* {t("Contract Exposure")}{" "} */}
                                      {t("Net Investment")}{" "}
                                      <Tooltip content={t("NetInvestment_Tooltip")}>
                                          <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                  </label>
                                  <div className="col-xl-6 d-flex" style={{ justifyContent: 'space-between' }}>
                                      <span className=" view-label p">
                                          {
                                              contract.status === "Active" ?

                                                  contract.contract_type === "Rental" ?
                                                      (
                                                          // Helper.Amount(contractdetail.totalRent * contractdetail.Contract.contract_term + contractdetail.residalvalue)
                                                          Helper.Amount(netinvest || 0)
                                                      )
                                                      :
                                                      (
                                                          Helper.Amount(Loanpricipal || 0)
                                                      )
                                                  : 0.00
                                          }
                                      </span>
                                  </div>
                              </div>
                              )
                            }
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}

export default ContractShortview;
